import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getSubindustryListData } from './mockData'
import type { ISubindustry } from '~/types/industry/models'

// get

interface GetSubindustriesResponse {
  data: ISubindustry[]
}

async function getSubindustries(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSubindustriesResponse = {
    data: await getSubindustryListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postSubindustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getSubindustryListData)
}

const patchSubindustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSubindustryListData)
}

const deleteSubindustry = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSubindustryListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/subindustries',
    handler: getSubindustries,
  },
  {
    method: 'post',
    path: '/api/subindustries',
    handler: postSubindustry,
  },
  {
    method: 'patch',
    path: '/api/subindustries/:id',
    handler: patchSubindustry,
  },
  {
    method: 'delete',
    path: '/api/subindustries/:id',
    handler: deleteSubindustry,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
